var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-treeview',{staticClass:"py-3",attrs:{"items":_vm.items,"search":_vm.search,"selectable":"","return-object":"","dense":""},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }